export const SLOTS = {
  titleGroup: "title-group",
};
